<template>
    <router-view></router-view>
</template>
<script>
export default {
    name: "app",
};
</script>
<style lang="scss">
$fa-font-path: "~font-awesome/fonts/";
@import "~font-awesome/scss/font-awesome.scss";

/* Import Simple Line Icons Set */
$simple-line-font-path: "~simple-line-icons/fonts/";
@import "~simple-line-icons/scss/simple-line-icons.scss";

@import "~flag-icon-css/css/flag-icon.min.css";

@import "~bootstrap/dist/css/bootstrap.css";
@import "assets/scss/style";
</style>
